<template>
    <v-container fluid grid-list-lg>
        <v-layout>
            <v-flex>
                <h1 class="display-3">Gestión de eventos</h1>
            </v-flex>
        </v-layout>
        <v-layout>
            <v-flex>
                <v-card>
                    <v-toolbar flat>
                        <v-spacer></v-spacer>
                        <v-tooltip top>
                            <v-btn flat small icon color="green" dark @click.native.stop="crudDialog = true; oper = 'add'" slot="activator">
                                <v-icon>add</v-icon>
                            </v-btn>
                            <span>Agregar evento</span>
                        </v-tooltip>
                    </v-toolbar>
                    <v-data-table :headers="headers"
                                  :items="items"
                                  :pagination.sync="pag"
                                  :total-items="totalItems"
                                  :loading="loading"
                                  :rows-per-page-items="rows"
                                  rows-per-page-text="Filas por pagina"
                                  class="elevation-1">
                        <template slot="items" slot-scope="props">
                            <td class="text-xs-center">{{ props.item.id }}</td>
                            <td class="text-xs-center">{{ props.item.evento }}</td>
                            <td class="text-xs-center">{{ props.item.empresa }}</td>
                            <td class="text-xs-center">{{ props.item.desde }}</td>
                            <td class="text-xs-center">{{ props.item.hasta }}</td>
                            <td class="text-xs-center">
                                <v-btn icon class="blue--text" small @click="editar(props.item.id)">
                                    <v-icon>edit</v-icon>
                                </v-btn>
                            </td>
                        </template>
                    </v-data-table>
                </v-card>
            </v-flex>
        </v-layout>
        <v-dialog v-model="crudDialog" scrollable>
            <v-card>
                <v-card-title>
                    <div class="display-2">{{ titulo }} registro</div>
                </v-card-title>
                <v-card-text>
                    <form>
                        <v-container fluid grid-list-md>
                            <v-layout row wrap>
                                <v-flex>
                                    <v-text-field
                                            required
                                            v-validate="'required|max:12'"
                                            :error-messages="errores.collect('form.desig')"
                                            name="form.desig"
                                            label="Nombre"
                                            v-model="form.desig">
                                    </v-text-field>
                                </v-flex>
                                <v-flex>
                                    <v-menu
                                            ref="menuDesde"
                                            lazy
                                            :close-on-content-click="false"
                                            v-model="menuDesde"
                                            transition="scale-transition"
                                            offset-y
                                            full-width
                                            :nudge-right="40"
                                            max-width="290px"
                                            min-width="290px"
                                    >
                                        <v-text-field slot="activator" label="Desde..." v-model="form.desde" prepend-icon="event" readonly></v-text-field>
                                        <v-date-picker v-model="form.desde" no-title scrollable locale="es">
                                            <v-spacer></v-spacer>
                                            <v-btn flat color="primary" @click="menuDesde = false">Cancel</v-btn>
                                            <v-btn flat color="primary" @click="$refs.menuDesde.save(date)">OK</v-btn>
                                        </v-date-picker>
                                    </v-menu>
                                </v-flex>
                                <v-flex>
                                    <v-menu
                                            ref="menuHasta"
                                            lazy
                                            :close-on-content-click="false"
                                            v-model="menuHasta"
                                            transition="scale-transition"
                                            offset-y
                                            full-width
                                            :nudge-right="40"
                                            max-width="290px"
                                            min-width="290px"
                                    >
                                        <v-text-field slot="activator" label="Hasta..." v-model="form.hasta" prepend-icon="event" readonly></v-text-field>
                                        <v-date-picker v-model="form.hasta" no-title scrollable locale="es">
                                            <v-spacer></v-spacer>
                                            <v-btn flat color="primary" @click="menuHasta = false">Cancel</v-btn>
                                            <v-btn flat color="primary" @click="$refs.menuHasta.save(date)">OK</v-btn>
                                        </v-date-picker>
                                    </v-menu>
                                </v-flex>
                            </v-layout>
                            <v-layout>
                                <v-flex>
                                    <empresa-select v-model="form.empresa_id" @input="updateListas()"></empresa-select>
                                </v-flex>
                                <v-flex>
                                    <v-select
                                            :items="depositos"
                                            v-model="form.deposito_id"
                                            label="Seleccione Depósito"
                                            item-text="desig"
                                            item-value="id"
                                            chips
                                            small-chips
                                            multiple
                                    ></v-select>
                                </v-flex>
                            </v-layout>
                            <v-layout>
                                <v-flex>
                                    <v-select
                                            :items="familias"
                                            v-model="form.familia_id"
                                            label="Seleccione Familia"
                                            item-text="BM_DESC"
                                            item-value="BM_GRUPO"
                                            chips
                                            multiple
                                    ></v-select>
                                </v-flex>
                            </v-layout>
                            <v-layout>
                                <v-flex>
                                    <v-text-field name="desde" label="Rango Desde" v-model="rango.desde"></v-text-field>
                                </v-flex>
                                <v-flex>
                                    <v-text-field name="hasta" label="Rango Hasta" v-model="rango.hasta"></v-text-field>
                                </v-flex>
                                <v-flex>
                                    <v-btn @click.native="rangoAdd" color="primary">
                                        Agregar Rango
                                    </v-btn>
                                </v-flex>
                            </v-layout>
                        </v-container>

                        <h6>Rangos</h6>
                        <v-chip close @input="rangoDel(key)" v-for="(r,key) in form.rangos" :key="key">{{ r.desde }} - {{ r.hasta }}</v-chip>
                    </form>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn flat color="red" @click.native="crudDialog = false">
                        cancelar
                    </v-btn>
                    <v-btn flat color="green" @click.native="guardar()" :loading="loading">
                        guardar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>
<script>
    import eventoMixins from '../../../mixins/stock/evento'
    import empresaMixins from '../../../mixins/empresa'
    import familiaMixins from '../../../mixins/familia'
    import empresaSelect from '../../../components/EmpresaSelect.vue'
    import {mapActions} from 'vuex';

    function getInitialData() {
        return {
            id:'',
            desig: '',
            desde: null,
            hasta: null,
            empresa_id: '',
            rangos: [],
            deposito_id: [],
            familia_id: []
        }
    }

    export default {
        $_veeValidate: {
            validator: 'new'
        },
        mixins: [eventoMixins, empresaMixins, familiaMixins],
        components: {empresaSelect},
        data() {
            return {
                oper: 'add',
                crudDialog: false,
                search: '',
                totalItems: 0,
                headers: [
                    {text: 'ID', value: 'evento.id', align: 'center'},
                    {text: 'Evento', value: 'evento.desig', align: 'center'},
                    {text: 'Empresa', value: 'empresa.desig', align: 'center'},
                    {text: 'Desde', value: 'desde', align: 'center'},
                    {text: 'Hasta', value: 'hasta', align: 'center'},
                    {text: 'Oper', value: '', align: 'center'},
                ],
                items: [],
                pag: {},
                rows: [10, 20, 30, {text: 'All', value: -1}],
                valid: false,
                loading: false,
                menuDesde: false,
                menuHasta: false,
                form: getInitialData(),
                rango: {desde: '', hasta: ''},
                depositos: [],
                familias: [],
            }
        },
        computed: {
            titulo() {
                return (this.oper === 'add') ? 'Agregar' : 'Editar'
            }
        },
        watch: {
            pag: {
                handler() {
                    this.tabla();
                },
                deep: true
            }
        },
        mounted() {
            this.tabla()
        },
        methods: {
            ...mapActions('notif', ['msjShow']),
            updateListas() {
                this.empresaDepositos(this.form.empresa_id, r => {
                    this.depositos = r
                }, err => {
                    alert(err)
                })
                this.familiaSelect(this.form.empresa_id, r => {
                    this.familias = r
                }, err => {
                    alert(err)
                })
            },
            rangoAdd() {
                this.form.rangos.push({desde: this.rango.desde, hasta: this.rango.hasta})
                this.rango.desde = '';
                this.rango.hasta = '';
            },
            rangoDel(key) {
                this.form.rangos.splice(key, 1)
            },
            guardar() {
                this.$validator.validateAll()
                    .then(r => {
                        if (r) {
                            this.loading = true;
                            if (this.oper === 'add') {
                                this.eventoStore(this.form, r => {
                                    this.msjShow(r);
                                    this.loading = false;
                                    this.limpiar();
                                }, err => {
                                    this.loading = false;
                                    this.msjShow({tipo: 'error', txt: 'Error al guardar',});
                                })
                            } else {
                                this.eventoUpdate(this.form, r => {
                                    this.msjShow(r);
                                    this.limpiar();
                                    this.crudDialog = false;
                                    this.loading = false;
                                }, err => {
                                    this.loading = false;
                                    this.msjShow({tipo: 'error', txt: 'Error al guardar',});
                                })
                            }

                        }
                    })
                    .catch(() => {
                        this.loading = false
                        this.msjShow({tipo: 'error', txt: 'Error al guardar',});
                    })
            },
            tabla() {
                this.loading = true
                this.pag.search = this.search
                this.eventoIndex(this.pag).then(r => {
                    this.items = r.data
                    this.totalItems = r.total
                    this.loading = false
                })
            },
            limpiar() {
                this.form = getInitialData();
                this.$validator.reset()
            },
            editar(id) {
                this.oper = 'edit';
                this.loading = true;
                this.eventoShow(id, r => {
                    this.form.id = id;
                    this.form.desig = r.desig;
                    this.form.desde = r.desde;
                    this.form.hasta = r.hasta;
                    this.form.empresa_id = r.empresa_id;
                    this.form.familia_id = r.familias;
                    this.form.deposito_id = r.depositos;
                    for (let i in r.rangos) {
                        this.form.rangos.push({desde: r.rangos[i].desde, hasta: r.rangos[i].hasta})
                    }
                    this.updateListas();
                    this.crudDialog = true;
                    this.loading = false;
                }, err => {
                    console.log(err);
                    this.loading = false;
                })
            },
        }
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/pages/stock/evento/tabla.vue